import { render, staticRenderFns } from "./coverageArea.vue?vue&type=template&id=04e28564&"
import script from "./coverageArea.vue?vue&type=script&lang=js&"
export * from "./coverageArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports